export default "__VITE_ASSET__BsNCdEed__"